import type { ColumnDef } from '@/shared/types/table-filters.types';
import type { Candidate, CandidateStatus } from '../types/candidate.types';
import { CANDIDATE_STATUS_CONFIG } from '../types/candidate.types';

const CANDIDATE_STATUSES: CandidateStatus[] = ['DRAFT', 'PENDING', 'CONFIRMED', 'REJECTED'];

// Reuses the badge labels so the filter and the table never drift apart.
const CANDIDATE_STATUS_LABELS: Record<string, string> = Object.fromEntries(
  CANDIDATE_STATUSES.map((status) => [status, CANDIDATE_STATUS_CONFIG[status].label])
);

/** Filterable/sortable candidate fields, shared by the desktop table and the mobile cards. */
export const candidateTableColumns: ColumnDef<Candidate>[] = [
  {
    key: 'name',
    label: 'Name',
    filterType: 'text',
    accessor: (candidate) => candidate.name,
    sortable: true,
  },
  {
    key: 'email',
    label: 'Email',
    filterType: 'text',
    accessor: (candidate) => candidate.email,
    sortable: true,
  },
  {
    key: 'country',
    label: 'Country',
    filterType: 'text',
    accessor: (candidate) => candidate.country,
    sortable: true,
  },
  {
    key: 'status',
    label: 'Status',
    filterType: 'select',
    accessor: (candidate) => candidate.status,
    options: CANDIDATE_STATUSES,
    optionLabels: CANDIDATE_STATUS_LABELS,
    sortable: true,
  },
  {
    key: 'consentGiven',
    label: 'Consent',
    filterType: 'boolean',
    accessor: (candidate) => candidate.consentGiven,
    sortable: true,
  },
  {
    key: 'createdAt',
    label: 'Created',
    filterType: 'date-range',
    accessor: (candidate) => candidate.createdAt,
    sortable: true,
  },
];
